import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableImagingStudyFragment = { readonly __typename?: 'SyncableImagingStudy', readonly id: string, readonly accessionNumber: string, readonly elephantPatientId?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncImagingStudyPushMutationVariables = Types.Exact<{
  input: Types.PushImagingStudyInput;
}>;


export type SyncImagingStudyPushMutation = { readonly __typename?: 'Mutation', readonly pushImagingStudy: { readonly __typename?: 'PushImagingStudyResponse', readonly rows: ReadonlyArray<{ readonly __typename?: 'SyncableImagingStudy', readonly id: string, readonly accessionNumber: string, readonly elephantPatientId?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export type ImagingStudyPullQueryVariables = Types.Exact<{
  input: Types.PullImagingStudyInput;
}>;


export type ImagingStudyPullQuery = { readonly __typename?: 'Query', readonly pullImagingStudy: { readonly __typename?: 'PullImagingStudyResponse', readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableImagingStudy', readonly id: string, readonly accessionNumber: string, readonly elephantPatientId?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableImagingStudyFragmentDoc = gql`
    fragment WholeSyncableImagingStudy on SyncableImagingStudy {
  id
  accessionNumber
  elephantPatientId
  meta {
    createdAt
    updatedAt
    createdByUserId
    updatedByUserId
    deleted
  }
}
    `;
export const SyncImagingStudyPushDocument = gql`
    mutation SyncImagingStudyPush($input: PushImagingStudyInput!) {
  pushImagingStudy(input: $input) {
    rows {
      ...WholeSyncableImagingStudy
    }
  }
}
    ${WholeSyncableImagingStudyFragmentDoc}`;
export type SyncImagingStudyPushMutationFn = Apollo.MutationFunction<SyncImagingStudyPushMutation, SyncImagingStudyPushMutationVariables>;

/**
 * __useSyncImagingStudyPushMutation__
 *
 * To run a mutation, you first call `useSyncImagingStudyPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncImagingStudyPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncImagingStudyPushMutation, { data, loading, error }] = useSyncImagingStudyPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncImagingStudyPushMutation(baseOptions?: Apollo.MutationHookOptions<SyncImagingStudyPushMutation, SyncImagingStudyPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncImagingStudyPushMutation, SyncImagingStudyPushMutationVariables>(SyncImagingStudyPushDocument, options);
      }
export type SyncImagingStudyPushMutationHookResult = ReturnType<typeof useSyncImagingStudyPushMutation>;
export type SyncImagingStudyPushMutationResult = Apollo.MutationResult<SyncImagingStudyPushMutation>;
export type SyncImagingStudyPushMutationOptions = Apollo.BaseMutationOptions<SyncImagingStudyPushMutation, SyncImagingStudyPushMutationVariables>;
export const ImagingStudyPullDocument = gql`
    query ImagingStudyPull($input: PullImagingStudyInput!) {
  pullImagingStudy(input: $input) {
    documents {
      ...WholeSyncableImagingStudy
    }
  }
}
    ${WholeSyncableImagingStudyFragmentDoc}`;

/**
 * __useImagingStudyPullQuery__
 *
 * To run a query within a React component, call `useImagingStudyPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useImagingStudyPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImagingStudyPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImagingStudyPullQuery(baseOptions: Apollo.QueryHookOptions<ImagingStudyPullQuery, ImagingStudyPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImagingStudyPullQuery, ImagingStudyPullQueryVariables>(ImagingStudyPullDocument, options);
      }
export function useImagingStudyPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImagingStudyPullQuery, ImagingStudyPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImagingStudyPullQuery, ImagingStudyPullQueryVariables>(ImagingStudyPullDocument, options);
        }
export type ImagingStudyPullQueryHookResult = ReturnType<typeof useImagingStudyPullQuery>;
export type ImagingStudyPullLazyQueryHookResult = ReturnType<typeof useImagingStudyPullLazyQuery>;
export type ImagingStudyPullQueryResult = Apollo.QueryResult<ImagingStudyPullQuery, ImagingStudyPullQueryVariables>;